import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Database } from "lucide-react";
import { useI18n } from "@/hooks/useI18n";
import type { AdminStatsResponse } from "@/lib/admin/hooks/useEdgeFunctionStats";
import UsageBar from "@/lib/admin/components/UsageBar";

interface QuotaCardProps {
  usage: AdminStatsResponse["usage"];
}

export function QuotaCard({ usage }: QuotaCardProps) {
  const { t } = useI18n();

  const formatNumber = (v: number | null) =>
    v != null ? v.toLocaleString() : "—";

  return (
    <Card>
      <CardHeader className="flex flex-row items-center gap-3 pb-3">
        <div className="flex items-center justify-center h-9 w-9 rounded-lg bg-purple-50 text-purple-600 flex-shrink-0">
          <Database className="h-5 w-5" />
        </div>
        <CardTitle className="text-base font-semibold">
          {t("adminDashboard.quota.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <UsageBar
          label={t("adminDashboard.quota.dbSize")}
          used={usage.db_size_bytes}
          limit={usage.db_size_limit_bytes}
        />
        <UsageBar
          label={t("adminDashboard.quota.storage")}
          used={usage.storage_size_bytes}
          limit={usage.storage_size_limit_bytes}
        />
        <UsageBar
          label={t("adminDashboard.quota.bandwidth")}
          used={usage.bandwidth_bytes}
          limit={usage.bandwidth_limit_bytes}
        />
        <UsageBar
          label={t("adminDashboard.quota.mau")}
          used={usage.monthly_active_users}
          limit={usage.mau_limit}
          formatValue={formatNumber}
        />
        <UsageBar
          label={t("adminDashboard.quota.invocations")}
          used={usage.func_invocations_month}
          limit={usage.func_invocations_limit}
          formatValue={formatNumber}
        />
      </CardContent>
    </Card>
  );
}

export default QuotaCard;
